import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { Image } from 'antd';

import useLocalizedTime from '../../../hooks/useLocalizedTime';
import TextBreaks from '../../../components/TextBreaks/TextBreaks';
import { convertToAbsoluteUrl, getValueByLanguage } from '../../../utils';
import styles from './styles.module.css';
import './style.css';
import { OrderUsageTicket } from '@shared/order/get/types';

const CouponTickets = ({ couponTickets = [] }: { couponTickets: OrderUsageTicket[] }) => {
    const [visible, setVisible] = useState(false);
    const { t } = useTranslation();
    const { formatTime } = useLocalizedTime();

    return (
        <div className={styles.couponTicketList}>
            {couponTickets
                .filter((item) => item.status === 'used')
                .map((item, index) => {
                    const imageUrl = convertToAbsoluteUrl(item.spotImageCircle);
                    return (
                        <div key={index} className={styles.couponTicketItem}>
                            <p className={styles.couponNumber}>
                                {t('ticket-detail.coupon-ordinal', { number: item.itemNumber })}
                            </p>
                            {item.activatedSpotName && (
                                <div className={styles.activatedSpotName}>
                                    {t('ticket-detail.address') + ': '}
                                    <TextBreaks text={getValueByLanguage(item.activatedSpotName, i18n.language)} />
                                </div>
                            )}
                            {item.activatedAt && (
                                <div className={styles.activatedAt}>
                                    {t('ticket-detail.activated-date') + ': ' + formatTime(item.activatedAt, 'lll')}
                                </div>
                            )}
                            {item.spotImageCircle && imageUrl && (
                                <>
                                    <div className={styles.spotImageCircle} onClick={() => setVisible(true)}>
                                        {t('ticket-detail.coupon-image')}
                                    </div>
                                    <Image
                                        style={{ display: 'none' }}
                                        preview={{
                                            src: imageUrl,
                                            visible,
                                            onVisibleChange: (value) => {
                                                setVisible(value);
                                            },
                                        }}
                                    />
                                </>
                            )}
                        </div>
                    );
                })}
        </div>
    );
};

export default memo(CouponTickets);
